// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1463":"fb29eba7","3243":"0fcffb0f","3555":"0fcffb0f","4746":"fb29eba7","5940":"fb29eba7","8136":"fb29eba7","8216":"c30d3525"}[chunkId] + ".chunk.css";
};